export default "__VITE_ASSET__ClUPTDH$__"